var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('QuizChoiceForm',{attrs:{"data":_vm.data,"staticAnswers":false,"title":_vm.$t('QUIZZES.LABEL.MULTIPLE_CHOICE'),"multiSelect":true,"showManualCheck":_vm.showManualCheck}})}
var staticRenderFns = []

export { render, staticRenderFns }